import {VaccineModel} from '../../model/vaccine.model';

export const vaccinationsData: Record<string, VaccineModel> = {
  C: {
    abbreviation: "C",
    fullName: "vaccinations_C",
    disclaimer: "vaccinations_C_disclaimer",
    leaflet: "https://ptmr.info.pl/wp-content/uploads/2024/12/Szczepienie-przeciw-COVID-19-w.-20232024-roku.pdf",
    chpl: [
      {
        name: 'Comirnaty',
        url: 'https://drive.google.com/file/d/1npXIYojMk4q-qHGX-3d8Thmsxs4SMoKb/view?usp=drive_link'
      },
      {
        name: 'Spikevax',
        url: 'https://drive.google.com/file/d/1Lqw7j2qWuBCQkELdIHwSc5fWLwh5aMpy/view?usp=drive_link'
      },
      {
        name: 'Vaxzevria',
        url: 'https://drive.google.com/file/d/1ah2n4L3nDySxMK28vKqNvVFIGNijIp16/view?usp=drive_link'
      },
      {
        name: 'JCOVDEN',
        url: 'https://drive.google.com/file/d/1MqhJDDI9pVN_19RCOAIfojvg2aDXPoq6/view?usp=drive_link'
      },
      {
        name: 'Nuvaxovid',
        url: 'https://drive.google.com/file/d/1Icsnm6MFu1UsBKh8XwXTfeoSnKvoaYw4/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "c_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "c_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "c_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "c_vaccinationSchema_60_64",
    vaccinationSchema_65: "c_vaccinationSchema_65",
    vaccinationSchema_pregnant: "c_vaccinationSchema_pregnant"
  },
  GR:  {
    abbreviation: "GR",
    fullName: "vaccinations_GR",
    disclaimer: "vaccinations_GR_disclaimer",
    leaflet: "https://ptmr.info.pl/wp-content/uploads/2024/12/Szczepienie-przeciw-grypie.pdf",
    chpl: [
      {
        name: 'Influvac Tetra',
        url: 'https://drive.google.com/file/d/17lqYX6L-JDtQlNGRNYOeTMzCOfzoChpu/view?usp=drive_link'
      },
      {
        name: 'Vaxigrip Tetra',
        url: 'https://drive.google.com/file/d/1ZCDlDFQM316b3DQ9DozNuMxwCa2kn4UQ/view?usp=drive_link'
      },
      {
        name: 'Fluarix Tetra',
        url: 'https://drive.google.com/file/d/1Ag4f1POcYCvNF6dkCT0OCq-w4fvmJXNU/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "gr_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "gr_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "gr_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "gr_vaccinationSchema_60_64",
    vaccinationSchema_65: "gr_vaccinationSchema_65",
    vaccinationSchema_pregnant: "gr_vaccinationSchema_pregnant"
  },
  GR_HD:  {
    abbreviation: "GR_HD",
    fullName: "vaccinations_GR_HD",
    disclaimer: "vaccinations_GR_HD_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Efluelda Tetra',
        url: 'https://drive.google.com/file/d/1czxiOxcAH9cQN5B6_nbX96wuH_nMAGqV/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "gr_hd_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "gr_hd_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "gr_hd_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "gr_hd_vaccinationSchema_60_64",
    vaccinationSchema_65: "gr_hd_vaccinationSchema_65",
    vaccinationSchema_pregnant: "gr_hd_vaccinationSchema_pregnant"
  },
  RSV:  {
    abbreviation: "RSV",
    fullName: "vaccinations_RSV",
    disclaimer: "vaccinations_RSV_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Abrysvo',
        url: 'https://drive.google.com/file/d/1Ba049s-_C6oC4eOjmcdYXfC-yO2RPOvO/view?usp=drive_link'
      },
      {
        name: 'Arexvy',
        url: 'https://drive.google.com/file/d/1y2nVYG9d1i991theUU48-JY9zPIWjaYe/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "rsv_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "rsv_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "rsv_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "rsv_vaccinationSchema_60_64",
    vaccinationSchema_65: "rsv_vaccinationSchema_65",
    vaccinationSchema_pregnant: "rsv_vaccinationSchema_pregnant"
  },
  RSV_1:  {
    abbreviation: "RSV_1",
    fullName: "vaccinations_RSV_1",
    disclaimer: "vaccinations_RSV_1_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Abrysvo',
        url: 'https://drive.google.com/file/d/1Ba049s-_C6oC4eOjmcdYXfC-yO2RPOvO/view?usp=drive_link'
      },
      {
        name: 'Arexvy',
        url: 'https://drive.google.com/file/d/1y2nVYG9d1i991theUU48-JY9zPIWjaYe/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "rsv_1_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "rsv_1_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "rsv_1_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "rsv_1_vaccinationSchema_60_64",
    vaccinationSchema_65: "rsv_1_vaccinationSchema_65",
    vaccinationSchema_pregnant: "rsv_1_vaccinationSchema_pregnant"
  },
  RSV_2:  {
    abbreviation: "RSV_2",
    fullName: "vaccinations_RSV_2",
    disclaimer: "vaccinations_RSV_2_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Abrysvo',
        url: 'https://drive.google.com/file/d/1Ba049s-_C6oC4eOjmcdYXfC-yO2RPOvO/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "rsv_2_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "rsv_2_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "rsv_2_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "rsv_2_vaccinationSchema_60_64",
    vaccinationSchema_65: "rsv_2_vaccinationSchema_65",
    vaccinationSchema_pregnant: "rsv_2_vaccinationSchema_pregnant"
  },
  NM:  {
    abbreviation: "NM",
    fullName: "vaccinations_NM",
    disclaimer: "vaccinations_NM_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Bexsero (Men B)',
        url: 'https://drive.google.com/file/d/1yw7pvuxNEKrK3BG0-Ma3ZmsjgvOROP_y/view?usp=drive_link'
      },
      {
        name: 'Trumenba (Men B)',
        url: 'https://drive.google.com/file/d/1fUGyYXeZuLfxpYEcgo6vAZM_DyMoSDWe/view?usp=drive_link'
      },
      {
        name: 'Nimenrix (Men ACWY)',
        url: 'https://drive.google.com/file/d/1HqO6xLkkpKz_eltu-u5mnevif6_BYXyC/view?usp=drive_link'
      },
      {
        name: 'Menveo (Men ACWY)',
        url: 'https://drive.google.com/file/d/1OlO9fwar2AdtLePvVkgIKYnM_t3SoOUW/view?usp=drive_link'
      },
      {
        name: 'MenQuadfi (Men ACWY)',
        url: 'https://drive.google.com/file/d/1RVW8XwF6kcHVfeNVK0jLiDsy2wco7FeV/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "nm_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "nm_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "nm_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "nm_vaccinationSchema_60_64",
    vaccinationSchema_65: "nm_vaccinationSchema_65",
    vaccinationSchema_pregnant: "nm_vaccinationSchema_pregnant"
  },
  NM_1:  {
    abbreviation: "NM_1",
    fullName: "vaccinations_NM_1",
    disclaimer: "vaccinations_NM_1_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Bexsero (Men B)',
        url: 'https://drive.google.com/file/d/1yw7pvuxNEKrK3BG0-Ma3ZmsjgvOROP_y/view?usp=drive_link'
      },
      {
        name: 'Trumenba (Men B)',
        url: 'https://drive.google.com/file/d/1fUGyYXeZuLfxpYEcgo6vAZM_DyMoSDWe/view?usp=drive_link'
      },
      {
        name: 'Nimenrix (Men ACWY)',
        url: 'https://drive.google.com/file/d/1HqO6xLkkpKz_eltu-u5mnevif6_BYXyC/view?usp=drive_link'
      },
      {
        name: 'Menveo (Men ACWY)',
        url: 'https://drive.google.com/file/d/1OlO9fwar2AdtLePvVkgIKYnM_t3SoOUW/view?usp=drive_link'
      },
      {
        name: 'MenQuadfi (Men ACWY)',
        url: 'https://drive.google.com/file/d/1RVW8XwF6kcHVfeNVK0jLiDsy2wco7FeV/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "nm_1_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "nm_1_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "nm_1_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "nm_1_vaccinationSchema_60_64",
    vaccinationSchema_65: "nm_1_vaccinationSchema_65",
    vaccinationSchema_pregnant: "nm_1_vaccinationSchema_pregnant"
  },
  SP:  {
    abbreviation: "SP",
    fullName: "vaccinations_SP",
    disclaimer: "vaccinations_SP_disclaimer",
    leaflet: "https://ptmr.info.pl/wp-content/uploads/2024/12/Szczepienie-przeciw-pneumokokom.pdf",
    chpl: [
      {
        name: 'Synflorix',
        url: 'https://drive.google.com/file/d/1g5ZRFVQEsxb-omRew80OahD3KbQt6_TV/view?usp=drive_link'
      },
      {
        name: 'Prevenar 13',
        url: 'https://drive.google.com/file/d/1VLfm-o6oAvfa3MCzVMsQIrheh9cRA8_z/view?usp=drive_link'
      },
      {
        name: 'Prevenar 20',
        url: 'https://drive.google.com/file/d/1NLOSTPy02H7_D-69XhXdOFGv6cJOXGVc/view?usp=drive_link'
      },
      {
        name: 'Pneumovax 23',
        url: 'https://drive.google.com/file/d/1eej7-yGUREicBqzp8nDBJo0rfNs9OBEM/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "sp_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "sp_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "sp_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "sp_vaccinationSchema_60_64",
    vaccinationSchema_65: "sp_vaccinationSchema_65",
    vaccinationSchema_pregnant: "sp_vaccinationSchema_pregnant"
  },
  SP_1:  {
    abbreviation: "SP_1",
    fullName: "vaccinations_SP_1",
    disclaimer: "vaccinations_SP_1_disclaimer",
    leaflet: "https://ptmr.info.pl/wp-content/uploads/2024/12/Szczepienie-przeciw-pneumokokom.pdf",
    chpl: [
      {
        name: 'Synflorix',
        url: 'https://drive.google.com/file/d/1g5ZRFVQEsxb-omRew80OahD3KbQt6_TV/view?usp=drive_link'
      },
      {
        name: 'Prevenar 13',
        url: 'https://drive.google.com/file/d/1VLfm-o6oAvfa3MCzVMsQIrheh9cRA8_z/view?usp=drive_link'
      },
      {
        name: 'Prevenar 20',
        url: 'https://drive.google.com/file/d/1NLOSTPy02H7_D-69XhXdOFGv6cJOXGVc/view?usp=drive_link'
      },
      {
        name: 'Pneumovax 23',
        url: 'https://drive.google.com/file/d/1eej7-yGUREicBqzp8nDBJo0rfNs9OBEM/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "sp_1_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "sp_1_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "sp_1_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "sp_1_vaccinationSchema_60_64",
    vaccinationSchema_65: "sp_1_vaccinationSchema_65",
    vaccinationSchema_pregnant: "sp_1_vaccinationSchema_pregnant"
  },
  HiB:  {
    abbreviation: "HiB",
    fullName: "vaccinations_HiB",
    disclaimer: "vaccinations_HiB_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Act HIB',
        url: 'https://drive.google.com/file/d/1yapt7WIIOiVCIJH-R7oRRM1rVi9oOdZ8/view?usp=drive_link'
      },
      {
        name: 'Infanrix-IPV + Hib (5w1)',
        url: 'https://drive.google.com/open?id=1eFTIEJQm6RSKBmgAO2GE-EaO8lCYvw_X&usp=drive_copy'
      },
      {
        name: 'Pentaxim (5w1)',
        url: 'https://drive.google.com/open?id=1rXSYJ_QNzE_ZP2v0Frx3778nz6cTvAB3&usp=drive_copy'
      },
      {
        name: 'Infanrix hexa (6w1)',
        url: 'https://drive.google.com/file/d/17PPBoWo0535zgFUCAxu6mQ5yuim4FnDO/view?usp=drive_link'
      },
      {
        name: 'Hexacima (6w1)',
        url: 'https://drive.google.com/file/d/142FN9jXXv8-Y5_Tc0UrczpPg2pLQHjdD/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "hib_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "hib_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "hib_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "hib_vaccinationSchema_60_64",
    vaccinationSchema_65: "hib_vaccinationSchema_65",
    vaccinationSchema_pregnant: "hib_vaccinationSchema_pregnant"
  },
  HiB_1:  {
    abbreviation: "HiB_1",
    fullName: "vaccinations_HiB_1",
    disclaimer: "vaccinations_HiB_1_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Act HIB',
        url: 'https://drive.google.com/file/d/1yapt7WIIOiVCIJH-R7oRRM1rVi9oOdZ8/view?usp=drive_link'
      },
      {
        name: 'Infanrix-IPV + Hib (5w1)',
        url: 'https://drive.google.com/open?id=1eFTIEJQm6RSKBmgAO2GE-EaO8lCYvw_X&usp=drive_copy'
      },
      {
        name: 'Pentaxim (5w1)',
        url: 'https://drive.google.com/open?id=1rXSYJ_QNzE_ZP2v0Frx3778nz6cTvAB3&usp=drive_copy'
      },
      {
        name: 'Infanrix hexa (6w1)',
        url: 'https://drive.google.com/file/d/17PPBoWo0535zgFUCAxu6mQ5yuim4FnDO/view?usp=drive_link'
      },
      {
        name: 'Hexacima (6w1)',
        url: 'https://drive.google.com/file/d/142FN9jXXv8-Y5_Tc0UrczpPg2pLQHjdD/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "hib_1_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "hib_1_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "hib_1_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "hib_1_vaccinationSchema_60_64",
    vaccinationSchema_65: "hib_1_vaccinationSchema_65",
    vaccinationSchema_pregnant: "hib_1_vaccinationSchema_pregnant"
  },
  KZM:  {
    abbreviation: "KZM",
    fullName: "vaccinations_KZM",
    disclaimer: "vaccinations_KZM_disclaimer",
    leaflet: "https://ptmr.info.pl/wp-content/uploads/2024/12/Szczepienie-przeciw-kleszczowemu-zapaleniu-mozgu.pdf",
    chpl: [
      {
        name: 'FSME-Immun',
        url: 'https://drive.google.com/file/d/19tfCzxeznvg-yxUYObLE7gpVzS0XJSHD/view?usp=drive_link'
      },
      {
        name: 'FSME-Immun Junior',
        url: 'https://drive.google.com/file/d/1e_dVURR_HWN2wGt9fmVUFKA_AVQRC-4F/view?usp=drive_link'
      },
      {
        name: 'Encepur Adults',
        url: 'https://drive.google.com/file/d/1qtQSm50DGqLngadhQKVZ0WhrdDzJTzRu/view?usp=drive_link'
      },
      {
        name: 'Encepur K',
        url: 'https://drive.google.com/file/d/1YtG2Mdb9zj7ugX9cuqWu2Ey8Eu828Hl7/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "kzm_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "kzm_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "kzm_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "kzm_vaccinationSchema_60_64",
    vaccinationSchema_65: "kzm_vaccinationSchema_65",
    vaccinationSchema_pregnant: "kzm_vaccinationSchema_pregnant"
  },
  WA:  {
    abbreviation: "WA",
    fullName: "vaccinations_WA",
    disclaimer: "vaccinations_WA_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Avaxim 160 U',
        url: 'https://drive.google.com/open?id=18tdpfXiODIwCaFx2ROQHtW8KUzrrSEPo&usp=drive_copy'
      },
      {
        name: 'Havrix 720 Junior',
        url: 'https://drive.google.com/file/d/1lpf9I3S6AUKHkc3debAD390F8ALnF8WE/view?usp=drive_link'
      },
      {
        name: 'Havrix Adult',
        url: 'https://drive.google.com/file/d/19b4Cmx9jSbFT7_x962EXGgH7L0XEml4q/view?usp=drive_link'
      },
      {
        name: 'Twinrix Adult (WZW A+B)',
        url: 'https://drive.google.com/file/d/1wvyFVXj7PHxW6kF5kUw7KV2RTmpL47YO/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "wa_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "wa_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "wa_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "wa_vaccinationSchema_60_64",
    vaccinationSchema_65: "wa_vaccinationSchema_65",
    vaccinationSchema_pregnant: "wa_vaccinationSchema_pregnant"
  },
  WB_1:  {
    abbreviation: "WB_1",
    fullName: "vaccinations_WB_1",
    disclaimer: "vaccinations_WB_1_disclaimer",
    leaflet: "https://ptmr.info.pl/wp-content/uploads/2025/02/szczepienia_dorosli_11022025.pdf",
    chpl: [
      {
        name: 'Engerix B 10',
        url: 'https://drive.google.com/file/d/1Mwh4jhQMTa0x8UIMrGL4LaeQEc_1Vraz/view?usp=drive_link'
      },
      {
        name: 'Engerix B 20',
        url: 'https://drive.google.com/file/d/1cS4vKFRdyeCF-v0AFFhdp6_5awMD5C28/view?usp=drive_link'
      },
      {
        name: 'Euvax B 10',
        url: 'https://drive.google.com/file/d/1mgx_M-6mXjCaIyvm5w64ZpxNz7lQEIZT/view?usp=drive_link'
      },
      {
        name: 'Engerix B 20',
        url: 'https://drive.google.com/file/d/1wyeBG6fVMyjrR0J3qbRcCy97UOHnpZHj/view?usp=drive_link'
      },
      {
        name: 'Twinrix Adult (WZW A+B)',
        url: 'https://drive.google.com/file/d/1wvyFVXj7PHxW6kF5kUw7KV2RTmpL47YO/view?usp=drive_link'
      },
      {
        name: 'Infanrix hexa (6w1)',
        url: 'https://drive.google.com/file/d/17PPBoWo0535zgFUCAxu6mQ5yuim4FnDO/view?usp=drive_link'
      },
      {
        name: 'Hexacima (6w1)',
        url: 'https://drive.google.com/file/d/142FN9jXXv8-Y5_Tc0UrczpPg2pLQHjdD/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "wb_1_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "wb_1_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "wb_1_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "wb_1_vaccinationSchema_60_64",
    vaccinationSchema_65: "wb_1_vaccinationSchema_65",
    vaccinationSchema_pregnant: "wb_1_vaccinationSchema_pregnant"
  },
  WB_2:  {
    abbreviation: "WB_2",
    fullName: "vaccinations_WB_2",
    disclaimer: "vaccinations_WB_2_disclaimer",
    leaflet: "https://ptmr.info.pl/wp-content/uploads/2025/02/szczepienia_dorosli_11022025.pdf",
    chpl: [
      {
        name: 'Engerix B 10',
        url: 'https://drive.google.com/file/d/1Mwh4jhQMTa0x8UIMrGL4LaeQEc_1Vraz/view?usp=drive_link'
      },
      {
        name: 'Engerix B 20',
        url: 'https://drive.google.com/file/d/1cS4vKFRdyeCF-v0AFFhdp6_5awMD5C28/view?usp=drive_link'
      },
      {
        name: 'Euvax B 10',
        url: 'https://drive.google.com/file/d/1mgx_M-6mXjCaIyvm5w64ZpxNz7lQEIZT/view?usp=drive_link'
      },
      {
        name: 'Engerix B 20',
        url: 'https://drive.google.com/file/d/1wyeBG6fVMyjrR0J3qbRcCy97UOHnpZHj/view?usp=drive_link'
      },
      {
        name: 'Twinrix Adult (WZW A+B)',
        url: 'https://drive.google.com/file/d/1wvyFVXj7PHxW6kF5kUw7KV2RTmpL47YO/view?usp=drive_link'
      },
      {
        name: 'Infanrix hexa (6w1)',
        url: 'https://drive.google.com/file/d/17PPBoWo0535zgFUCAxu6mQ5yuim4FnDO/view?usp=drive_link'
      },
      {
        name: 'Hexacima (6w1)',
        url: 'https://drive.google.com/file/d/142FN9jXXv8-Y5_Tc0UrczpPg2pLQHjdD/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "wb_2_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "wb_2_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "wb_2_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "wb_2_vaccinationSchema_60_64",
    vaccinationSchema_65: "wb_2_vaccinationSchema_65",
    vaccinationSchema_pregnant: "wb_2_vaccinationSchema_pregnant"
  },
  MMR_1:  {
    abbreviation: "MMR_1",
    fullName: "vaccinations_MMR_1",
    disclaimer: "vaccinations_MMR_1_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Priorix',
        url: 'https://drive.google.com/file/d/1tO_VuemVSbwkNjRnAgq91ELgir3taSsk/view?usp=drive_link'
      },
      {
        name: 'M-M-RvaxPro',
        url: 'https://drive.google.com/file/d/1aKbU1sPgm-CnMSRozvM-UwT95MTVujAq/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "mmr_1_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "mmr_1_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "mmr_1_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "mmr_1_vaccinationSchema_60_64",
    vaccinationSchema_65: "mmr_1_vaccinationSchema_65",
    vaccinationSchema_pregnant: "mmr_1_vaccinationSchema_pregnant"
  },
  DTP:  {
    abbreviation: "DTP",
    fullName: "vaccinations_DTP",
    disclaimer: "vaccinations_DTP_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Adacel',
        url: 'https://drive.google.com/file/d/1kFnF_qYWEnFUkZiGebwdsj8GrtrRfGJ4/view?usp=drive_link'
      },
      {
        name: 'Boostrix',
        url: 'https://drive.google.com/file/d/1IqNiEeAkYpWwXofYUZQ38IkcBEIzpZyP/view?usp=drive_link'
      },
      {
        name: 'Tdap-Szczepionka',
        url: 'https://drive.google.com/file/d/1QacuLZ5CIcwvJq40jeOPwbwsNL7hEkrS/view?usp=drive_link'
      },
      {
        name: 'Adacel Polio (DTP+polio)',
        url: 'https://drive.google.com/file/d/1qSra1-GFYW0jKJXVZdZ3B9H-FJjehKPc/view?usp=drive_link'
      },
      {
        name: 'Boostrix Polio (DTP+polio)',
        url: 'https://drive.google.com/file/d/1whA0twLZ-Lh2XLbjLd3Gpz5_VeuFbQrY/view?usp=sharing'
      },
      {
        name: 'Infanrix IPV (DTP+polio)',
        url: 'https://drive.google.com/file/d/1T0vbNAu0ngTzdPDMtNUN2Y2k0PNGQo4s/view?usp=drive_link'
      },
      {
        name: 'Tetraxim (DTP+polio)',
        url: 'https://drive.google.com/file/d/19Pg0186Ra8CPRR-Q5SsXe42JY4ecKdKd/view?usp=drive_link'
      },
      {
        name: 'Infanrix-IPV + Hib (5w1)',
        url: 'https://drive.google.com/open?id=1eFTIEJQm6RSKBmgAO2GE-EaO8lCYvw_X&usp=drive_copy'
      },
      {
        name: 'Pentaxim​ (5w1)',
        url: 'https://drive.google.com/open?id=1rXSYJ_QNzE_ZP2v0Frx3778nz6cTvAB3&usp=drive_copy'
      },
      {
        name: 'Infanrix hexa (6w1)',
        url: 'https://drive.google.com/file/d/17PPBoWo0535zgFUCAxu6mQ5yuim4FnDO/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "dtp_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "dtp_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "dtp_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "dtp_vaccinationSchema_60_64",
    vaccinationSchema_65: "dtp_vaccinationSchema_65",
    vaccinationSchema_pregnant: "dtp_vaccinationSchema_pregnant"
  },
  DTP_1:  {
    abbreviation: "DTP_1",
    fullName: "vaccinations_DTP_1",
    disclaimer: "vaccinations_DTP_1_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Adacel',
        url: 'https://drive.google.com/file/d/1kFnF_qYWEnFUkZiGebwdsj8GrtrRfGJ4/view?usp=drive_link'
      },
      {
        name: 'Boostrix',
        url: 'https://drive.google.com/file/d/1IqNiEeAkYpWwXofYUZQ38IkcBEIzpZyP/view?usp=drive_link'
      },
      {
        name: 'Tdap-Szczepionka',
        url: 'https://drive.google.com/file/d/1QacuLZ5CIcwvJq40jeOPwbwsNL7hEkrS/view?usp=drive_link'
      },
      {
        name: 'Adacel Polio (DTP+polio)',
        url: 'https://drive.google.com/file/d/1qSra1-GFYW0jKJXVZdZ3B9H-FJjehKPc/view?usp=drive_link'
      },
      {
        name: 'Boostrix Polio (DTP+polio)',
        url: 'https://drive.google.com/file/d/1SrM-3FaYlvHOiTOL1I9QjMJu_1VcdQSR/view?usp=drive_link'
      },
      {
        name: 'Infanrix IPV (DTP+polio)',
        url: 'https://drive.google.com/file/d/1T0vbNAu0ngTzdPDMtNUN2Y2k0PNGQo4s/view?usp=drive_link'
      },
      {
        name: 'Tetraxim (DTP+polio)',
        url: 'https://drive.google.com/file/d/19Pg0186Ra8CPRR-Q5SsXe42JY4ecKdKd/view?usp=drive_link'
      },
      {
        name: 'Infanrix-IPV + Hib (5w1)',
        url: 'https://drive.google.com/open?id=1eFTIEJQm6RSKBmgAO2GE-EaO8lCYvw_X&usp=drive_copy'
      },
      {
        name: 'Pentaxim​ (5w1)',
        url: 'https://drive.google.com/open?id=1rXSYJ_QNzE_ZP2v0Frx3778nz6cTvAB3&usp=drive_copy'
      },
      {
        name: 'Infanrix hexa (6w1)',
        url: 'https://drive.google.com/file/d/17PPBoWo0535zgFUCAxu6mQ5yuim4FnDO/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "dtp_1_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "dtp_1_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "dtp_1_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "dtp_1_vaccinationSchema_60_64",
    vaccinationSchema_65: "dtp_1_vaccinationSchema_65",
    vaccinationSchema_pregnant: "dtp_1_vaccinationSchema_pregnant"
  },
  HPV:  {
    abbreviation: "HPV",
    fullName: "vaccinations_HPV",
    disclaimer: "vaccinations_HPV_disclaimer",
    leaflet: "https://ptmr.info.pl/wp-content/uploads/2023/07/hpv_2401.pdf",
    chpl: [
      {
        name: 'Cervarix',
        url: 'https://drive.google.com/file/d/1tv6I32PPZ2DOkydVW-Hv-UzhBf0woZEY/view?usp=drive_link'
      },
      {
        name: 'Gardasil',
        url: 'https://drive.google.com/file/d/1O3MS6TbpLTwddwL_LC8AONTIYrtW4EiH/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "hpv_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "hpv_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "hpv_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "hpv_vaccinationSchema_60_64",
    vaccinationSchema_65: "hpv_vaccinationSchema_65",
    vaccinationSchema_pregnant: "hpv_vaccinationSchema_pregnant"
  },
  OW_1:  {
    abbreviation: "OW_1",
    fullName: "vaccinations_OW_1",
    disclaimer: "vaccinations_OW_1_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Varilrix',
        url: 'https://drive.google.com/file/d/1qwBtoHve9RKjyVbbSPQ_fd3wRg0N1Eck/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "ow_1_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "ow_1_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "ow_1_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "ow_1_vaccinationSchema_60_64",
    vaccinationSchema_65: "ow_1_vaccinationSchema_65",
    vaccinationSchema_pregnant: "ow_1_vaccinationSchema_pregnant"
  },
  HZV_1:  {
    abbreviation: "HZV_1",
    fullName: "vaccinations_HZV_1",
    disclaimer: "vaccinations_HZV_1_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Shingrix',
        url: 'https://drive.google.com/file/d/16A8Xsgg9EyxZdD3ZGnx0fVu_d8U2Fk8-/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "hzv_1_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "hzv_1_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "hzv_1_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "hzv_1_vaccinationSchema_60_64",
    vaccinationSchema_65: "hzv_1_vaccinationSchema_65",
    vaccinationSchema_pregnant: "hzv_1_vaccinationSchema_pregnant"
  },
  PO_1:  {
    abbreviation: "PO_1",
    fullName: "vaccinations_PO_1",
    disclaimer: "vaccinations_PO_1_disclaimer",
    leaflet: "https://ptmr.info.pl/wp-content/uploads/2023/07/polpasiec_2401.pdf",
    chpl: [
      {
        name: 'Imovax Polio',
        url: 'https://drive.google.com/file/d/1069ea120Btwvxn60Ra_NvBkzCLkyb5qF/view?usp=drive_link'
      },
      {
        name: 'Adacel Polio (DTP+polio)',
        url: 'https://drive.google.com/file/d/1qSra1-GFYW0jKJXVZdZ3B9H-FJjehKPc/view?usp=drive_link'
      },
      {
        name: 'Boostrix Polio (DTP+polio)',
        url: 'https://drive.google.com/file/d/1SrM-3FaYlvHOiTOL1I9QjMJu_1VcdQSR/view?usp=drive_link'
      },
      {
        name: 'Infanrix IPV (DTP+polio)',
        url: 'https://drive.google.com/file/d/1T0vbNAu0ngTzdPDMtNUN2Y2k0PNGQo4s/view?usp=drive_link'
      },
      {
        name: 'Tetraxim (DTP+polio)',
        url: 'https://drive.google.com/file/d/19Pg0186Ra8CPRR-Q5SsXe42JY4ecKdKd/view?usp=drive_link'
      },
      {
        name: 'Infanrix-IPV + Hib (5w1)',
        url: 'https://drive.google.com/open?id=1eFTIEJQm6RSKBmgAO2GE-EaO8lCYvw_X&usp=drive_copy'
      },
      {
        name: 'Pentaxim (5w1)',
        url: 'https://drive.google.com/open?id=1rXSYJ_QNzE_ZP2v0Frx3778nz6cTvAB3&usp=drive_copy'
      },
      {
        name: 'Infanrix hexa (6w1)',
        url: 'https://drive.google.com/file/d/17PPBoWo0535zgFUCAxu6mQ5yuim4FnDO/view?usp=drive_link'
      },
      {
        name: 'Hexacima (6w1)',
        url: 'https://drive.google.com/file/d/142FN9jXXv8-Y5_Tc0UrczpPg2pLQHjdD/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "po_1_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "po_1_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "po_1_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "po_1_vaccinationSchema_60_64",
    vaccinationSchema_65: "po_1_vaccinationSchema_65",
    vaccinationSchema_pregnant: "po_1_vaccinationSchema_pregnant"
  },
  ZG:  {
    abbreviation: "ZG",
    fullName: "vaccinations_ZG",
    disclaimer: "vaccinations_ZG_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Stamaril',
        url: 'https://drive.google.com/file/d/1Qy6vKEhaGkxUES_T7LlSi9BPC_qRaVg5/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "zg_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "zg_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "zg_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "zg_vaccinationSchema_60_64",
    vaccinationSchema_65: "zg_vaccinationSchema_65",
    vaccinationSchema_pregnant: "zg_vaccinationSchema_pregnant"
  },
  JZM:  {
    abbreviation: "JZM",
    fullName: "vaccinations_JZM",
    disclaimer: "vaccinations_JZM_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Ixiaro',
        url: 'https://drive.google.com/file/d/1v6uKddG9cdfBi6vo6yHrK8VLftIKNOCT/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "jzm_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "jzm_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "jzm_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "jzm_vaccinationSchema_60_64",
    vaccinationSchema_65: "jzm_vaccinationSchema_65",
    vaccinationSchema_pregnant: "jzm_vaccinationSchema_pregnant"
  },
  WS:  {
    abbreviation: "WS",
    fullName: "vaccinations_WS",
    disclaimer: "vaccinations_WS_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Verorab',
        url: 'https://drive.google.com/file/d/1hTHDLbZtVsX8QRA4zaM0nOhZHYq0ZKZC/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "ws_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "ws_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "ws_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "ws_vaccinationSchema_60_64",
    vaccinationSchema_65: "ws_vaccinationSchema_65",
    vaccinationSchema_pregnant: "ws_vaccinationSchema_pregnant"
  },
  DB:  {
    abbreviation: "DB",
    fullName: "vaccinations_DB",
    disclaimer: "vaccinations_DB_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Typhim Vi',
        url: 'https://drive.google.com/file/d/10S_Qn02FnlZ3Lpq0sOs3T8toRE376Yog/view?usp=drive_link'
      },
      {
        name: 'Vivotif',
        url: 'https://drive.google.com/file/d/1Pgufq-_8ICRYVMPBpU_-jrKXkNvDGG8G/view?usp=drive_link'
      },
      {
        name: 'Ty - Szczepionka durowa',
        url: 'https://drive.google.com/file/d/1eF_gw76nbrRD2PPqtoE7MgW05h3jzQMX/view?usp=drive_link'
      },
      {
        name: 'TyT - Szczepionka durowo-tężcowa',
        url: 'https://drive.google.com/file/d/1-JQho2eL92n23mQx_Z4NQ2EDmr-31DK8/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "db_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "db_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "db_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "db_vaccinationSchema_60_64",
    vaccinationSchema_65: "db_vaccinationSchema_65",
    vaccinationSchema_pregnant: "db_vaccinationSchema_pregnant"
  },
  CH:  {
    abbreviation: "CH",
    fullName: "vaccinations_CH",
    disclaimer: "vaccinations_CH_disclaimer",
    leaflet: "https://ptmr.info.pl/brak-ulotki/",
    chpl: [
      {
        name: 'Dukoral',
        url: 'https://drive.google.com/file/d/1aS5YXB9aHh0_ClVJU0A7DAbCRyd9EUg9/view?usp=drive_link'
      },
      {
        name: 'Vaxchora',
        url: 'https://drive.google.com/file/d/1AHnAw6Wl3GpMA6-FT9YXJY-U7dZr-sdw/view?usp=drive_link'
      }
    ],
    vaccinationSchema_18_49: "ch_vaccinationSchema_18_49",
    vaccinationSchema_50_54: "ch_vaccinationSchema_50_54",
    vaccinationSchema_55_59: "ch_vaccinationSchema_55_59",
    vaccinationSchema_60_64: "ch_vaccinationSchema_60_64",
    vaccinationSchema_65: "ch_vaccinationSchema_65",
    vaccinationSchema_pregnant: "ch_vaccinationSchema_pregnant"
  }
}
